<!-- 
  uploadimage組件使用説明
  disabled 是否可讀 布爾值 
  imageUrlList 上傳返回的圖片地址，數組格式
  oldImageUrlList 顯示已存在的圖片地址列表 相對路徑
  舊文件存入參考
  file_list: [
          {id:1,url: '/upload/file/20200529/159073903121616.jpg' },
          {id:2,url: '/upload/file/20200529/159073903121616.jpg' },
          {id:3,url: '/upload/file/20200529/159073903121616.jpg' },
        ], // 旧文件列表
  listType elementUI顯示類型，	text/picture/picture-card 
  -->
<template>
  <div id="UploadImage">
    <el-upload :disabled="uploadDisabled" :file-list="fileList" :action="actionUrl" :on-change="uploadChange" :data="uploadToken" :list-type="listType2" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess" :before-upload="beforeUpload" :on-error="hanldeError" accept=".jpg,.jpeg.,.png,.JPG,.JPEG">
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true" hight="80%" top="5vh">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'UploadImage',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    imageUrlList: {
      type: Array,
      default: () => []
    },
    oldImageUrlList: {
      type: Array,
      default: () => []
    },
    listType: {
      type: String,
      default: 'picture-card',
    },
    fileDir: {
      type: String,
      default: 'office',
    },
    watermark: {
      type: Boolean,
      default: true
    },
    clear: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      uploadDisabled: false,
      dialogImageUrl: '',
      dialogVisible: false,
      upload_list: [],
      uploadToken: {
        token: "",
        username: "",
      },
      fileList: [],
      listType2: '',
    };
  },
  methods: {
    hanldeError (error) {
      console.log(error);
    },
    handleRemove (file, fileList) {
      if (file.response) {
        var index = this.upload_list.indexOf(file.response.url)
        // 同步刪除服務器返回的上傳地址
        this.upload_list.splice(index, 1);
        this.$emit('update:imageUrlList', this.upload_list);
      } else {
        var index = this.fileList.indexOf(file)
        this.fileList.splice(index, 1);
        this.$emit('update:oldImageUrlList', this.fileList);
      }
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess (res, file) {
      // 把服務器返回的圖片地址保存到數組中
      if (res.status == 'success') {
        this.upload_list.push(res.url)
        this.$emit('update:imageUrlList', this.upload_list);
      }
    },
    // 方法判断
    uploadChange (file, fileList) {
      // console.log(fileList);
      // 清空
      if (this.clear) {
        this.upload_list = [];
        if (fileList.length > 1) {
          fileList.shift();
        }
      }
      // 拿到当前上传图片的name，判断其后缀名是否符合
      let type = isImage(file.name);
      // console.log(type);
      this.fileList = fileList;
      let fileLength = this.fileList.length;
      if (!type) {
        // 若不符合图片类型，则让当前上传的文件去除掉即可，即从上传对列删除本次上传
        this.fileList.splice(fileLength - 1, 1);
        this.$message.error(this.$t('message.uploadImgMsg'));
      }
      this.isHasDataChange = true;

    },
    beforeUpload (file) {
      let _this = this
      return new Promise((resolve, reject) => {
        let isLt2M = file.size / 1024 / 1024 < 2 // 判定图片大小是否小于2MB
        // if (isLt2M) {
        //   resolve(file);
        // }
        let image = new Image(), resultBlob = '';
        image.src = URL.createObjectURL(file);
        image.onload = () => {
          // 调用方法获取blob格式，方法写在下边
          resultBlob = _this.compressUpload(image, file);
          resolve(resultBlob);
        }
        image.onerror = () => {
          reject();
        }
      })
    },

    /* 图片压缩方法-canvas压缩和加水印 */
    compressUpload (image, file) {
      let canvas = document.createElement('canvas');
      let ctx = canvas.getContext('2d');

      let initSize = image.src.length;
      let { width } = image, { height } = image;
      canvas.width = width;
      canvas.height = height;

      let watermark = this.watermark;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0, width, height);
      if (watermark) {
        let fontSize = '25px';
        let fontWidth = 10;
        if (width > 1000 && height > 1000) {
          fontSize = '50px';
          fontWidth = 15;
        } else if (width > 500 && height > 500) {
          fontSize = '30px';
          fontWidth = 10;
        } else if (width < 300 && height < 300) {
          fontSize = '15px';
          fontWidth = 2;
        }

        //获取地点 时间 
        let dataa = new Date();
        // let copyText = dataa.getFullYear() + "/" + (dataa.getMonth() + 1) + "/" + dataa.getDate() + ' ' + 'Copy! Copy! Copy!';
        let copyText = 'Copy! Copy! Copy!';

        // 绘制水印到canvas上
        for (let i = 0; i < 50; i++) {
          ctx.rotate((-45 * Math.PI) / 180); // 水印初始偏转角度
          ctx.font = `${fontSize} 微软雅黑`; // 字体
          ctx.fillStyle = "rgba(0,0,0,0.3)"; // 字体颜色
          ctx.fillText(copyText, -(copyText.length * fontWidth), i * (height / 2) + 30);
          ctx.rotate((45 * Math.PI) / 180); // 把水印偏转角度调整为原来的，不然他会一直转
        }
      }


      // 进行最小压缩0.1
      let compressData = canvas.toDataURL(file.type || 'image/jpeg', 0.5);

      // 压缩后调用方法进行base64转Blob，方法写在下边
      let blobImg = this.dataURItoBlob(compressData);
      return blobImg;
    },

    compressUpload_bf (image, file) {
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      let initSize = image.src.length
      let { width } = image, { height } = image
      canvas.width = width
      canvas.height = height
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(image, 0, 0, width, height)

      // 进行最小压缩0.1
      let compressData = canvas.toDataURL(file.type || 'image/jpeg', 0.3)

      // 压缩后调用方法进行base64转Blob，方法写在下边
      let blobImg = this.dataURItoBlob(compressData)
      return blobImg
    },

    /* base64转Blob对象 */
    dataURItoBlob (data) {
      let byteString;
      if (data.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(data.split(',')[1])
      } else {
        byteString = unescape(data.split(',')[1])
      }
      let mimeString = data
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
      let ia = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    }
  },
  computed: {
    actionUrl () {
      return this.apiurl + '/api/upload/upload_img';
    }
  },
  created () {
    this.uploadToken.token = this.sessionRead('token');
    this.uploadToken.username = this.sessionRead('username');
    this.uploadToken.mso_id = this.sessionRead('mso_id');
    this.uploadToken.fileDir = this.fileDir;
    if (this.oldImageUrlList.length > 0) {
      this.fileList = this.oldImageUrlList.map(item => {
        item.url = item.url;
        return item;
      });
    } else {
      this.fileList = this.oldImageUrlList;
    }

    // console.log(this.fileList);
    this.listType2 = this.listType;
    this.uploadDisabled = this.disabled || false;
  },
  watch: {
    disabled (val) {
      this.uploadDisabled = val;
    },
    oldImageUrlList (val) {
      if (val.length > 0) {
        this.fileList = this.oldImageUrlList.map(item => {
          item.url =  item.url;
          return item;
        });
      }else{
        this.fileList = this.oldImageUrlList;
      }
    }
  }
}

// 判斷是否為圖片
function isImage (fileName) {
  if (typeof fileName !== 'string') return;
  let name = fileName.toLowerCase();
  return name.endsWith('.png') || name.endsWith('.jpeg') || name.endsWith('.jpg') || name.endsWith('.png') || name.endsWith('.bmp');
}
</script>

<style>
</style>